<template>
  <div>
    <div class="zk-help-box">
      <a class="float-btn report" href="https://support.qq.com/products/297963">
        <i class="icon-shield"></i>
        <span>举报</span>
      </a>
    </div>
    <BackTop :height="150" :bottom="80" :right="80">
      <div class="float-btn back-top">
        <chevron-up-icon size="1.5x" class="icon-chevron-up"></chevron-up-icon>
      </div>
    </BackTop>
  </div>
</template>

<script>
import { ChevronUpIcon } from 'vue-feather-icons'

export default {
  name: 'ZkBackTop',
  components: {
    ChevronUpIcon
  }
}
</script>

<style lang="less">
.zk-help-box {
  position: fixed;
  bottom: 148px;
  right: 80px;
  font-size: 20px;

  .icon-shield {
    display: block;
    width: 18px;
    height: 22px;
    background-image: url('../../assets/icons/icon-shield.png');
  }
}

.float-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #ebeef5;
  color: #c0c4cc;
  background-color: #fff;
  cursor: pointer;

  &.report {
    font-size: 10px;
    color: #fff;
    background-color: #3771E5;

    span {
      line-height: 14px;
      transform: scale(0.83);
    }
  }

  &.back-top {
    &:hover {
      color: #3771E5;
      border-color: #3771E5;
      transition: color .3s, border-color .3s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?006e9e76